module.exports = __webpack_public_path__ + "img/CE0000_default_F1.41127696.png";